import { normalize, denormalize } from 'normalizr';
import { combineEpics, ofType } from 'redux-observable';
import {
  switchMap, catchError, mergeMap, map,
} from 'rxjs/operators';
import api from 'api/index';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import { tagSchema, tagsSchema } from '../../../store/schema';
import {
  createTagSuccess,
  deleteTagSuccess,
  fetchAllTagsSuccess,
  updateTagSuccess,
} from './actions';
import { entitiesFetchSuccess } from '../../../store/entities/actions';
import { getEntities } from '../../../store/entities/selectors';


const fetchAll = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_ALL),
  switchMap(() => api.tags.fetchAll().pipe(
    map((response) => normalize(response.body, tagsSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchAllTagsSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


const createTag = (action$, state$) => action$.pipe(
  ofType(actionTypes.CREATE),
  switchMap((action) => {
    const tag = denormalize(action.tag, tagSchema, getEntities(state$.value));
    return api.tags.create(tag).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, tagSchema);
        return [
          entitiesFetchSuccess(entities),
          createTagSuccess(response.body),
        ];
      }),
      catchError((error) => [handleError(error)]),
    );
  }),
);


const updateTag = (action$, state$) => action$.pipe(
  ofType(actionTypes.UPDATE),
  switchMap((action) => {
    const tag = denormalize(action.tag, tagSchema, getEntities(state$.value));
    return api.tags.update(tag).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, tagSchema);
        return [
          entitiesFetchSuccess(entities),
          updateTagSuccess(action.tag.id),
        ];
      }),
      catchError((error) => [handleError(error)]),
    );
  }),
);


const deleteTag = (action$) => action$.pipe(
  ofType(actionTypes.DELETE),
  switchMap((action) => api.tags.delete(action.tag).pipe(
    mergeMap(() => [
      deleteTagSuccess(action.tag.id),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);

export default combineEpics(
  fetchAll,
  createTag,
  updateTag,
  deleteTag,
);
